import { Link, useHistory } from 'react-router-dom';
import useSWR from 'swr';
import { stringify } from 'query-string';
import { fetcher } from '../../common/api/fetcher';
import ErrorBox from '../../common/components/ErrorBox';
import React from 'react';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import { NoResults } from '../../common/components/NoResults';

export const GiveawaysDataList = ({ offset, limit, query }) => {
  const history = useHistory();
  const { data, error, revalidate } = useSWR(
    `/portal/giveaways?${stringify({
      offset,
      limit,
      ...(query !== '' && { query }),
    })}`,
    fetcher,
    { suspense: true }
  );

  if (error) {
    return (
      <ErrorBox
        title="Error"
        msg="There was an error fetching giveaways, please try again"
        onClose={revalidate}
      />
    );
  }

  if (data?.length === 0) {
    return <NoResults />;
  }

  return (
    <Table striped bordered hover>
      <tbody>
        {data.map((item) => (
          <tr key={item.id} className="cursor-pointer">
            <td onClick={() => history.push(`/giveaways/edit/${item.id}`)}>
              {item.title}
            </td>
            <td>
              <Button
                as={Link}
                variant="primary"
                type="button"
                className="border-orange-br bg-orange-br"
                to={`/giveaways/entries/${item.id}`}
              >
                Entries
              </Button>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};
